import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
  /** Align actions to the inline end (default true). */
  end?: boolean;
};

/**
 * Sticky composer/footer action bar primitive (V1B).
 * Pages adopt in V1D — available here without changing form handlers.
 * Clearance sentinel keeps final fields scrollable above the sticky bar (V1D-A.1).
 */
export function StickyFormActions({ children, className = "", end = true }: Props) {
  return (
    <>
      <div
        className="composer-sticky-clearance"
        data-vt-composer-sticky-clearance
        aria-hidden="true"
      />
      <div
        className={[
          "form-actions",
          "form-actions--sticky",
          end ? "form-actions--end" : "",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        data-vt-sticky-actions
      >
        {children}
      </div>
    </>
  );
}
